import Vue from 'vue'

Vue.filter('idCard', value => {
  let idCard = value.split('')
  idCard.splice(3, 0, ' ')
  idCard.splice(7, 0, ' ')
  idCard.splice(12, 0, ' ')
  idCard.splice(17, 0, ' ')
  return idCard.join('')
})
